export const routePaths = {
  home: "/",
  register: "/register",
  privacy: "/privacy",
  terms: "/terms",
  admin: {
    root: "/admin",
    login: "/admin/login",
    waitlist: "/admin/waitlist",
    settings: "/admin/settings"
  }
} as const;
